module.exports = __webpack_public_path__ + "img/hr-boiler-N-fire.c1fa716a.png";